export default {
  jsonCopy (item) {
    return JSON.parse(JSON.stringify(item))
  }
}



// WEBPACK FOOTER //
// ./src/utils/ObjectUtils.js